import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { isEmpty } from 'helpers/verify';
import { ACTIVITY_ICONS } from 'constants/icons';

import { Selector } from 'components/Selector/Selector';
import css from './VerticalsFilter.scss';

class VerticalsFilter extends PureComponent {
  handleToggleExpanded = () => {
    const { isEditing, onSetIsEditing } = this.props;

    onSetIsEditing(!isEditing);
  };

  render() {
    const { isMobile, items, onSelect, selectedItemName, selectedItemId, isEditing } = this.props;

    return (
      <Selector isMobile={isMobile} isSelected isOpen={isEditing} onToggle={this.handleToggleExpanded}>
        {({ DisclosureArrow, Panel, Selection }) =>
          !isEmpty(items) && (
            <div className="unified-filters__filter">
              <Selection>
                <LocalizableMessage message={selectedItemName} />
                <DisclosureArrow />
              </Selection>
              <Panel onClose={this.handleToggleExpanded}>
                <ul className="unified-filters__content">
                  {items.map(item => (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <li className="dropdown__item dropdown__item--circle" key={item.id} onClick={() => onSelect(item)}>
                      <Isvg
                        className={cx('dropdown__item__icon', css.icon)}
                        uniquifyIDs={false}
                        src={ACTIVITY_ICONS[item.id] || ACTIVITY_ICONS.default}
                      />
                      {/* NOTE: Before migrating this to CSS modules, please make sure to add a data-qa attribute
                          for selected status. */}
                      <p
                        className={cx('dropdown__item__content', {
                          'is-selected': selectedItemId === item.id,
                        })}>
                        <span className="dropdown__item__content__name">
                          <LocalizableMessage message={item.name} tagName="strong" />
                        </span>
                        {item.description && (
                          <span className="dropdown__item__content__description">
                            <LocalizableMessage message={item.description} />
                          </span>
                        )}
                      </p>
                      {selectedItemId === item.id && (
                        <Isvg
                          className="dropdown__item__checkmark"
                          uniquifyIDs={false}
                          src={require('style-guide/templates/static/assets/images/css/icons/checkmark-new.svg')}
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </Panel>
            </div>
          )
        }
      </Selector>
    );
  }
}

VerticalsFilter.propTypes = {
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: LocalizableMessageShape,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: LocalizableMessageShape,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedItemName: LocalizableMessageShape,
  selectedItemId: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onSetIsEditing: PropTypes.func.isRequired,
};

export { VerticalsFilter };
